export default __webpack_public_path__ + "static/media/LINK.e74bd143.svg";